// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__MlxFR","range":"MonthRangeSwitch_range__2axAB","disabled":"MonthRangeSwitch_disabled__3gLl0"};